import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6">© TMS</div>
          <div className="col-sm-6">
            <div className="text-sm-end d-none d-sm-block">
              {/* Design &amp; Develop by Codehimalaya */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
